import { useApiFetcherSWR } from "hooks/SwrCustom";

// ===================== API ENDPOINTS =====================

export const API_ENDPOINT = {
    // ================= Besturen =================

    COMMUNITY_LIST: {
        url: "organizations-list",
        method: "get",
    },

    FETCH_BESTUREN: {
        url: "instellingen/bestuur/lists",
        method: "get",
    },

    SAVE_BESTUREN: {
        url: "instellingen/bestuur/save-or-update",
        method: "post",
    },

    REPORTER_ADD_OR_REMOVE: {
        url: "instellingen/bestuur/toggle-user",
        method: "post",
    },

    COORDINATOR_LIST: {
        url: "instellingen/bestuur/coordinator-lists",
        method: "get",
    },

    SAVE_ICON: {
        url: "instellingen/bestuur/saveOrUpdatePlanning",
        method: "post",
    },

    SAVE_COORDINATOR_ICON: {
        url: "instellingen/bestuur/saveOrUpdatePlanning",
        method: "post",
    },

    REPLACEMENT_PROTOCOL: {
        url: "instellingen/bestuur/protocol-lists",
        method: "get",
    },

    REMOVE_REPLACEMENT_PROTOCOL: {
        url: "instellingen/bestuur/protocol-delete",
        method: "post",
    },

    SAVE_FILE: {
        url: "instellingen/bestuur/protocol-save",
        method: "post",
    },

    // ================= Contracttypen =================

    GET_FILTER: {
        url: "instellingen/contract/filter-show",
        method: "post",
    },

    SAVE_FILTER: {
        url: "instellingen/contract/filters-save",
        method: "post",
    },
    CONTRACT_FILTERS_LIST: {
    url: "instellingen/contract/filters-list",
    method: "get",
},
};

// ===================== BESTUREN HOOKS =====================

export const useCommunityList = () =>
    useApiFetcherSWR(API_ENDPOINT.COMMUNITY_LIST);

export const useFetchBesturen = (params) =>
    useApiFetcherSWR(
        params
            ? {
                  ...API_ENDPOINT.FETCH_BESTUREN,
                  params,
              }
            : null
    );
export const useSaveBesturen = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_BESTUREN);

export const useReporterListAddOrRemove = () =>
    useApiFetcherSWR(API_ENDPOINT.REPORTER_ADD_OR_REMOVE);

export const useCoordinatorList = () =>
    useApiFetcherSWR(API_ENDPOINT.COORDINATOR_LIST);

export const useSaveIcon = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_ICON);

export const useSaveCoordinatorIcon = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_COORDINATOR_ICON);

export const useReplacementProtocol = (iCommunityId) => {
    const shouldFetch = Boolean(iCommunityId);

    return useApiFetcherSWR(
        shouldFetch
            ? {
                url: API_ENDPOINT.REPLACEMENT_PROTOCOL.url,
                method: "get",
                params: {
                    iCommunityId,
                },
            }
            : null
    );
};

export const useRemoveReplacementProtocol = () =>
    useApiFetcherSWR(API_ENDPOINT.REMOVE_REPLACEMENT_PROTOCOL);

export const useSaveFile = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_FILE);

export const useContractFilter = (enabled = true) =>
    useApiFetcherSWR(
        enabled
            ? API_ENDPOINT.GET_FILTER
            : null
    );

export const useSaveContractFilter = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_FILTER);

export const useContractFiltersList = (communityId, contractId) => {
    const shouldFetch = Boolean(communityId && contractId);

    return useApiFetcherSWR(
        shouldFetch
            ? {
                  ...API_ENDPOINT.CONTRACT_FILTERS_LIST,
                  params: {
                      iCommunityId: communityId,
                      contractId: contractId,
                  },
              }
            : null
    );
};

export default API_ENDPOINT;